import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Nav from './pages/Nav'
import Footer from './pages/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import Careers from './pages/Careers'
import Accountingoutsourcing from './pages/Accountingoutsourcing'
import Accountsreceivableoutsourcing from './pages/Accountsreceivableoutsourcing'
import Accountspayableoutsourcing from './pages/Accountspayableoutsourcing'
import Bookkeepingoutsourcing from './pages/Bookkeepingoutsourcing'
import Migratingaccountingsystem from './pages/Migratingaccountingsystem'
import Internalandexternalauditing from './pages/Internalandexternalauditing'
import Inventoryaudit from './pages/Inventoryaudit'
import Bankreconciliation from './pages/Bankreconciliation'
import Intercompanyreconciliation from './pages/Intercompanyreconciliation'
import Goodsandservicestax from './pages/Goodsandservicestax'
import Taxdeductedatsource from './pages/Taxdeductedatsource'
import Pfesicpt from './pages/Pfesicpt'
import Financialreports from './pages/Financialreports'
import Payrollmanagement from './pages/Payrollmanagement'
import Manpowermanagement from './pages/Manpowermanagement'
import Sapaccounting from './pages/Sapaccounting'
import Ginesysaccounting from './pages/Ginesysaccounting'
import Tallyaccounting from './pages/Tallyaccounting'
import Opticonaccounting from './pages/Opticonaccounting'
import Quickbookaccounting from './pages/Quickbookaccounting'
import Maramiaccounting from './pages/Maramiaccounting'
import Constructionsandrealestate from './pages/Constructionsandrealestate'
import Textileandgarmentsindustry from './pages/Textileandgarmentsindustry'
import Interiordesign from './pages/Interiordesign'
import Constructionstoresstockaudit from './pages/Constructionstoresstockaudit'
import Retailstoresstockaudit from './pages/Retailstoresstockaudit'
import ManufacturingStockAudit from './pages/ManufacturingStockAudit'
import PharmaceuticalsStockAudit from './pages/PharmaceuticalsStockAudit'
import HealthcareStockAudit from './pages/HealthcareStockAudit'
import ConstructionStockAudit from './pages/ConstructionStockAudit'
import RetailStockAudit from './pages/RetailStockAudit'
import Manufacturing from './pages/Manufacturing'
import Pharmaceuticals from './pages/Pharmaceuticals'
import Healthcare from './pages/Healthcare'
import Focusaccountingsoftware from './pages/Focusaccountingsoftware'
import FusilAccounting from './pages/FusilAccounting'
import ProjectFundingBusinessLoans from './pages/ProjectFundingBusinessLoans'

 

 




const App = () => { 
  return (
    <div>

     
      <Nav /> 

       <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/accounting-outsourcing" element={<Accountingoutsourcing />} />
        <Route path="/accounts-receivable-outsourcing" element={<Accountsreceivableoutsourcing />} />
        <Route path="/accounts-payable-outsourcing" element = {<Accountspayableoutsourcing />} />
        <Route path="/bookkeeping-outsourcing"  element={<Bookkeepingoutsourcing/> } />
        <Route path="/migrating-accounting-system" element={<Migratingaccountingsystem />} />
        <Route path="/internal-and-external-auditing" element = {<Internalandexternalauditing />} />
        <Route path="/inventory-audit" element = { <Inventoryaudit /> } />
        <Route path="/bank-reconciliation" element={< Bankreconciliation />} />
        <Route path='/intercompany-reconciliation' element={<Intercompanyreconciliation />} />
        <Route path='/goods-and-services-tax-gst' element={<Goodsandservicestax />} />
        <Route path='/tax-deducted-at-source-tds' element={<Taxdeductedatsource />} />
        <Route path='/financial-reports' element={<Financialreports />} />
        <Route path='/payroll-management' element={<Payrollmanagement />} />
        <Route path='/manpower-management' element={<Manpowermanagement />} />
        <Route path='/sap-accounting' element={<Sapaccounting />} />
        <Route path='/ginesys-accounting' element={<Ginesysaccounting />} />
        <Route path='/tally-accounting' element={<Tallyaccounting />} />
        <Route path='/opticon-accounting' element={<Opticonaccounting />} />
        <Route path='/quickbook-accounting' element={<Quickbookaccounting />} />
        <Route path='/marami-accounting' element={<Maramiaccounting />} />
        <Route path='/constructions-and-real-estate' element={<Constructionsandrealestate/>} />
        <Route path='/textile-and-garments-industry' element={<Textileandgarmentsindustry />} />
        <Route path='/interior-design' element={<Interiordesign />} />
         <Route path='/construction-stores-stock-audit' element={<Constructionstoresstockaudit />}/>
         <Route path='/retail-stores-stock-audit' element={<Retailstoresstockaudit />} />
        <Route path='/pf-esic-pt' element={<Pfesicpt />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
        <Route path='/manufacturing-stock-audit' element={<ManufacturingStockAudit />} />
        <Route path='/pharmaceuticals-stock-audit' element={<PharmaceuticalsStockAudit />} />
        <Route path='/health-care-stock-audit' element={<HealthcareStockAudit />} />
        <Route path='/construction-stock-audit' element={<ConstructionStockAudit />} />
        <Route path='/retail-stock-audit' element={<RetailStockAudit />} />
        <Route path='/manufacturing-services' element={<Manufacturing />} />
        <Route path='/pharmaceuticals' element={<Pharmaceuticals />} />
        <Route path='/healthcare' element={<Healthcare />} />
        <Route path='/focus-accounting' element={<Focusaccountingsoftware />} />
        <Route path='/fusil-accounting' element={<FusilAccounting />} />
        <Route path='/project-funding-and-business-loans' element={<ProjectFundingBusinessLoans />} />
      </Routes>
    </Router>

   

      <Footer/>

      
      
    </div>
  )
}

export default App
